import axios from "axios";
import { ServerSideTypes } from "../common/OperationCommonTypes";
import { TransferReasonTypes } from "./Types";

const TransferReasonService = {
  get: {
    filterTransferReason: (
      data: TransferReasonTypes.SearchFunctionTypes,
      serverParams: ServerSideTypes.IParams
    ) => {
      return axios
        .get<ServerSideTypes.IResult<TransferReasonTypes.TableDataTypes>>(
          "/masterdatatransportation/transferrequest/pagination",
          {
            params: { ...data, ...serverParams },
          }
        )
        .then((response) => response.data);
    },
	exportTransferRequest: (
      data: TransferReasonTypes.SearchFunctionTypes,
    ) => {
      return axios
        .get<any>(
          "/masterdatatransportation/transferrequest/excel",
          {
            params: { ...data },
            responseType:"arraybuffer",
          }
        )
    },
    statusReason: (params: TransferReasonTypes.Reason) => {
      return axios
        .get<TransferReasonTypes.ReasonResponse[]>(
          "/masterdatavehicle/statusreason/all",
          { params: params }
        )
        .then((response) => response.data);
    },
    // location: (tenant: string) => {
    //   return axios
    //     .get<TransferReasonTypes.Location[]>(
    //       "/masterdatavehicle/location/all",
    //       { params: { tenant: tenant } }
    //     )
    //     .then((response) => response.data);
    // },
    locationsByFilters: (
      params: TransferReasonTypes.LocationsByFiltersRequest
    ) => {
      const p = new URLSearchParams();
      p.append("tenant", params.tenant);
      p.append("pageNumber", params.pageNumber.toString());
      p.append("pageSize", params.pageSize.toString());
      p.append("currentStatus", "CREATED");
      params.type?.map((t) => {
        p.append("type", t);
      });
      return axios
        .get("masterdatasupplier/location/locationsByFilters", {
          params: p,
        })
        .then((response) => response.data);
    },
    transferById: (id: any) => {
      return axios
        .get<any>(`/masterdatatransportation/transferrequest/${id}`)
        .then((response) => response.data);
    },
    drivers: (tenant: string) => {
      return axios
        .get<TransferReasonTypes.Drivers[]>(
          "/masterdatatransportation/driver/all",
          { params: { tenant: tenant } }
        )
        .then((response) => response.data);
    },
    vehicles: (tenant: string, plate: string) => {
      return axios
        .get<TransferReasonTypes.Drivers[]>(
          `/masterdatavehicle/vehicle/plate/${plate}`,
          { params: { tenant: tenant } }
        )
        .then((response) => response);
    },
    platesByLocationId: (locationId: string, locationType: string, tenant: string) => {
      return axios
        .get(`/masterdatavehicle/vehicle/location/${locationId}/${locationType}/transferable`, {
          params: { tenant: tenant },
        })
        .then((response) => response.data);
    },
    transferRequestDetails: (tenant: string, id?: string) => {
      return axios
        .get<TransferReasonTypes.TransferRequestDetails>(
          `/masterdatatransportation/transferrequest/${id}`,
          {
            params: { tenant: tenant },
          }
        )
        .then((response) => response.data);
    },
    carriersTender: (
      tenant: string,
      transferRequestNumber: string,
      serverParams: ServerSideTypes.IParams
    ) => {
      if (!transferRequestNumber)
        return Promise.resolve({
          content: [],
          pageNumber: serverParams.pageNumber,
          pageSize: serverParams.pageSize,
          totalElements: 1,
          totalPages: 0,
        } as ServerSideTypes.IResult<TransferReasonTypes.ICarrierTender>);

      return axios
        .get<ServerSideTypes.IResult<TransferReasonTypes.ICarrierTender>>(
          "/masterdatatransportation/transferrequest/carriersTender",
          {
            params: {
              tenant,
              transferRequestNumber,
              ...serverParams,
            },
          }
        )
        .then((response) => {
          return response.data;
        });
    },
    statusCounter: (tenant: string, data: TransferReasonTypes.SearchFunctionTypes, startStationId: string | undefined, 
      startStationType: string | undefined, expectedEndStationId: string | undefined,
      expectedEndStationType: string | undefined, endStationId: string | undefined,
      endStationType: string | undefined) =>  { 
      return axios
        .get("masterdatatransportation/transferrequest/statusCounter", {
          params: { 
            tenant,
            ...data, 
            startStationId, 
            startStationType, 
            expectedEndStationId,
            expectedEndStationType, 
            endStationId,
            endStationType},
        })
        .then((response) => response.data);
    },
  },
  put: {
    createTransferReason: (
      tenant: string,
      data: TransferReasonTypes.AddFunctionTypes
    ) => {
      return axios
        .post("/masterdatatransportation/transferrequest", data, {
          params: { tenant: tenant },
        })
        .then((response) => response);
    },
    deleteTransferReason: (id: number) => {
      return axios
        .delete(`/masterdatatransportation/gestional/transferRequest/${id}`)
        .then((response) => response);
    },
    approve: (tenant: string, id: string) => {
      return axios
        .put(
          `/masterdatatransportation/transferrequest/approve?tenant=${tenant}&id=${id}`
        )
        .then((response) => response);
    },
    ddt: (tenant: string, id: string) => {
      return axios
        .put(
          `/masterdatatransportation/transferrequest/ddt?tenant=${tenant}&id=${id}`
        )
        .then((response) => response);
    },
    reject: (tenant: string, id: number) => {
      return axios
        .put(
          `/masterdatatransportation/transferrequest/reject?tenant=${tenant}&id=${id}`
        )
        .then((response) => response);
    },
    editTransferReason: (
      id: string,
      data: TransferReasonTypes.AddFunctionTypes
    ) => {
      return axios
        .put(`/masterdatatransportation/gestional/transferRequest/${id}`, {
          params: {
            reasonCode: data.transferReasonCode,
            status: data.status,
            startStationId: data.startStationId,
            startDate: data.startDate,
            expectedEndStationId: data.expectedEndStationId,
            expectedEndDate: data.expectedEndDate,
            companyName: data.companyName,
            companyCity: data.companyCity,
            carSegmentsInfo: [
              {
                carSegmentId: "",
                vehiclesNum: "",
              },
            ],
            plates: data.plates,
            driversId: data.driversId,
          },
        })
        .then((response) => response);
    },
    sendInvitation: (
      tenant: string,
      transferId: number,
      carrierBpCode: string,
      data: TransferReasonTypes.ISendInvitation
    ) => {
      return axios.put(
        `/masterdatatransportation/transferrequest/${transferId}/invitation/carrierBpCode/${carrierBpCode}`,
        data,
        { params: { tenant } }
      );
    },
    approveTender: (
      tenant: string,
      transferId: number,
      data: TransferReasonTypes.TenderDetails
    ) => {
      return axios.put(
        `/masterdatatransportation/transferrequest/${transferId}/tenderWinner`,
        data,
        { params: { tenant } }
      );
    },
  },
};

export default TransferReasonService;
